import { CustomIcon } from "components/icon/customIcon.component";
import { Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { ApplicationResolution } from "model/Application";
import { CompanyWorkerDto, WorkerWithUrl } from "model/Company";
import { CompanyGig } from "model/Gig";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";
import { fetchWorker } from "web-apps/company/utils/utils";
import { ImageWrapper, SmallImage, WorkerCountWrapper } from "./gigs.styled";
import { WorkerDetail } from "../../timeReport/workers/workerDetail.component";

type Props = {
  gigData: CompanyGig;
  workerWithImageUrl?: WorkerWithUrl[];
  isActive?: boolean;
};

export const GigWorkerCount: React.FC<Props> = ({
  gigData,
  workerWithImageUrl,
  isActive,
}) => {
  const { t } = useTranslation();
  const [workerImages, setWorkerImages] = useState<(string | null)[]>([]);
  const maxImages = 5;
  const [workerIds, setWorkerIds] = useState<(number | null)[]>([]);
  const [companyState] = useCompanyStore();
  const [workerModalOpen, setWorkerModalOpen] = useState(false);
  const [worker, setWorker] = useState<CompanyWorkerDto>();

  useEffect(() => {
    if (!gigData.applications) return;

    const workerIds = gigData.applications.map(
      (application) => application.worker.id
    );

    const workerImageUrls = Array(gigData.amountOfWorkers).fill(null);

    workerIds.forEach((id, index) => {
      if (workerWithImageUrl) {
        workerWithImageUrl.forEach((workerWithImage) => {
          if (id === workerWithImage.workerId) {
            workerImageUrls[index] = workerWithImage.imageUrl;
          }
        });
      }
    });
    setWorkerImages(workerImageUrls);
    setWorkerIds(workerIds);
  }, [gigData.applications, workerWithImageUrl]);

  useEffect(() => {
    setWorkerModalOpen(true);
  }, [worker]);

  return (
    <>
      <WorkerCountWrapper>
        {workerImages.map((url, index) => {
          if (index < maxImages) {
            return (
              <ImageWrapper
                key={index}
                style={{ cursor: "pointer" }}
                onClick={() => {
                  const workerId = workerIds[index];
                  if (typeof workerId === "number") {
                    fetchWorker(workerId, companyState).then((worker) => {
                      setWorker(worker.data);
                    });
                  }
                }}
              >
                {url ? (
                  <SmallImage src={url} />
                ) : (
                  <CustomIcon
                    name="person"
                    size="100%"
                    color={Color.SeaBlue500}
                    padding="4px"
                  />
                )}
              </ImageWrapper>
            );
          }
        })}
        <Text color={Color.SeaBlue400} style={{ margin: 0 }}>
          {gigData?.applications
            ? gigData.applications.filter(
                (a) => a.resolution === ApplicationResolution.ACCEPTED
              ).length
            : 0}
          /{gigData.amountOfWorkers}
        </Text>
      </WorkerCountWrapper>
      {workerModalOpen && worker && (
        <WorkerDetail
          worker={worker}
          setWorkerModalOpen={setWorkerModalOpen}
          workerModalOpen={workerModalOpen}
        />
      )}
    </>
  );
};
